import React from 'react'
import { FilterEvents } from '../../Layout/FilterEvents/FilterEvents'
import './Style.css'

export const EventZone = () => {
  return (
    <div className="container-fluid p-0 d-flex justify-content-center">
      <FilterEvents/>
    </div>
  )
}




